import { ClassTypeOptions, ra, ra_property } from 'rest-adapter';

@ra(ClassTypeOptions.AddUnknownFields)
export class Asset {
    @ra_property()
    public key: string = '';

    @ra_property()
    public assetValue: string = '';

    @ra_property()
    public displayString: string = '';

    @ra_property()
    public locale: string = '';

    @ra_property()
    public uri: string = '';
}
